import { c as _c } from "react/compiler-runtime";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveLeaderboardGalleryItemVotesProps {
  readonly drop: ExtendedDrop;
  readonly variant?: "default" | "subtle" | undefined;
}
export default function WaveLeaderboardGalleryItemVotes(t0) {
  const $ = _c(15);
  const {
    drop,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const current = drop.rating ?? 0;
  const isPositive = current >= 0;
  let t2;
  if ($[0] !== isPositive || $[1] !== variant) {
    t2 = () => {
      if (variant === "subtle") {
        return "tw-text-iron-200";
      }
      return isPositive ? "tw-text-emerald-500" : "tw-text-rose-500";
    };
    $[0] = isPositive;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getColorClass = t2;
  const t3 = `tw-font-mono tw-text-sm tw-font-bold ${getColorClass()}`;
  let t4;
  if ($[3] !== current) {
    t4 = formatNumberWithCommas(current);
    $[3] = current;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = variant === "subtle";
  let t7;
  if ($[8] !== current || $[9] !== drop.rating_prediction || $[10] !== t6) {
    t7 = <DropVoteProgressing current={current} projected={drop.rating_prediction} subtle={t6} />;
    $[8] = current;
    $[9] = drop.rating_prediction;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}